import LoadableWrapper from './LoadableWrapper';

export default LoadableWrapper;
